var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewAddPlusWhiteGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 107,
    viewBox: "0 0 98 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_9870_8390)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 11,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 9.5,
    width: 67,
    height: 67,
    rx: 33.5,
    stroke: "url(#paint0_linear_9870_8390)",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.125 44.875H35.875C34.84 44.875 34 44.035 34 43C34 41.965 34.84 41.125 35.875 41.125H62.125C63.16 41.125 64 41.965 64 43C64 44.035 63.16 44.875 62.125 44.875Z",
    fill: "url(#paint1_linear_9870_8390)",
    stroke: "url(#paint2_linear_9870_8390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 58C47.965 58 47.125 57.16 47.125 56.125V29.875C47.125 28.84 47.965 28 49 28C50.035 28 50.875 28.84 50.875 29.875V56.125C50.875 57.16 50.035 58 49 58Z",
    fill: "url(#paint3_linear_9870_8390)",
    stroke: "url(#paint4_linear_9870_8390)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.928 102L34.88 93.024V102H33.248V90.512H35.168L41.072 99.248V90.512H42.704V102H40.928ZM48.5455 102.16C46.0975 102.16 44.4495 100.384 44.4495 97.712C44.4495 95.2 46.1615 93.36 48.4975 93.36C51.0255 93.36 52.7055 95.408 52.4175 98.16H46.0975C46.2255 99.888 47.0895 100.896 48.5135 100.896C49.7135 100.896 50.5455 100.24 50.8175 99.136H52.4175C52.0015 101.024 50.5455 102.16 48.5455 102.16ZM48.4655 94.576C47.1695 94.576 46.2895 95.504 46.1135 97.088H50.7055C50.6255 95.52 49.7775 94.576 48.4655 94.576ZM60.9561 102L59.0361 95.696L57.1001 102H55.4681L53.0201 93.52H54.6041L56.3161 99.696L58.2361 93.52H59.8361L61.7241 99.712L63.4361 93.52H65.0361L62.5721 102H60.9561Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_9870_8390",
    x: 4,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.647059 0 0 0 0 0.941176 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9870_8390"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_9870_8390",
    result: "effect2_dropShadow_9870_8390"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_9870_8390",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9870_8390",
    x1: 81.2058,
    y1: 93.8412,
    x2: -0.698523,
    y2: 65.2486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9870_8390",
    x1: 64.0965,
    y1: 45.979,
    x2: 59.2018,
    y2: 32.3092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9870_8390",
    x1: 64.0965,
    y1: 45.979,
    x2: 59.2018,
    y2: 32.3092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9870_8390",
    x1: 50.8871,
    y1: 66.8318,
    x2: 45.5133,
    y2: 66.5973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9870_8390",
    x1: 50.8871,
    y1: 66.8318,
    x2: 45.5133,
    y2: 66.5973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAddPlusWhiteGradient);
export default __webpack_public_path__ + "static/media/new_add_plus_white_gradient.3eb4b54e464f202b362b5173c7456b3e.svg";
export { ForwardRef as ReactComponent };